import { render, staticRenderFns } from "./BaseAssignment.vue?vue&type=template&id=4fc369ba&scoped=true&"
import script from "./BaseAssignment.vue?vue&type=script&lang=js&"
export * from "./BaseAssignment.vue?vue&type=script&lang=js&"
import style0 from "./BaseAssignment.vue?vue&type=style&index=0&id=4fc369ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc369ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCheckbox,VListItem,VSheet,VSkeletonLoader})
